import ApplicationUnredacted from "static/images/document_types/application_unredacted.png";
import BankLetter from "static/images/document_types/bank_letter.png";
import BankStatement from "static/images/document_types/bank_statement.png";
import BusinessLicense from "static/images/document_types/business_license.png";
import OtherUnderwritingDocument from "static/images/document_types/other_underwriting_documents.png";
import PhotoIdentification from "static/images/document_types/photo_identification.png";
import PreviousProcessorStatements from "static/images/document_types/previous_processor_statements.png";
import UnderwritingDocument from "static/images/document_types/sensitive.png";
import TaxReturn from "static/images/document_types/tax_return.png";
import UtilityBill from "static/images/document_types/utility_bill.png";
import VoidedCheck from "static/images/document_types/voided_check.png";
import AgentContract from "static/images/document_types/agentContract.svg";
import OtherDocument from "static/images/document_types/other_document.svg";
import ResidualSplitProfileEmail from "static/images/document_types/residualSplitProfileEmail.svg";
import SignedScheduleA from "static/images/document_types/signedScheduleA.svg";

export const FeeProgramByConstants = {
	INTERCHANGE_PLUS: 0,
	FLAT_RATE: 1,
	THREE_TIER: 2,
	ERR: 3,
	DUAL_FLAT_RATE: 4,
};

export const TransactionFeeTypeByValue = (
	transactionFeeTypeByValue,
	getEnumName = false,
) => {
	switch (parseFloat(transactionFeeTypeByValue)) {
		case FeeProgramByConstants.INTERCHANGE_PLUS:
			return getEnumName ? "InterchangePlus" : "Interchange Plus";
		case FeeProgramByConstants.FLAT_RATE:
			return getEnumName ? "FlatRate" : "Flat Rate";
		case FeeProgramByConstants.THREE_TIER:
			return getEnumName ? "ThreeTier" : "Three Tier";
		case FeeProgramByConstants.ERR:
			return "ERR";
		case FeeProgramByConstants.DUAL_FLAT_RATE:
			return getEnumName ? "DualFlatRate" : "Dual Flat Rate";
		default:
			return null;
	}
};

export const FeeProgramByValue = type => {
	switch (type) {
		case "InterchangePlus":
			return "Interchange Plus";
		case "FlatRate":
			return "Flat Rate";
		case "ThreeTier":
			return "3-Tier";
		case "ERR":
			return "ERR";
		case "DualFlatRate":
			return "Dual Flat Rate";
		default:
			return null;
	}
};

export const FeeProgramTypeByValue = type => {
	switch (type) {
		case "InterchangePlus":
			return FeeProgramByConstants.INTERCHANGE_PLUS;
		case "FlatRate":
			return FeeProgramByConstants.FLAT_RATE;
		case "ThreeTier":
			return FeeProgramByConstants.THREE_TIER;
		case "ERR":
			return FeeProgramByConstants.ERR;
		case "DualFlatRate":
			return FeeProgramByConstants.DUAL_FLAT_RATE;
		default:
			return null;
	}
};

export const MiscFeeType = miscFeeType => {
	switch (+miscFeeType) {
		case 0:
			return "Per Item";
		case 1:
			return "Monthly";
		case 2:
			return "Annually";
		default:
			return "Invalid";
	}
};

export const RefundPolicyByValue = (
	refundPolicyByValue,
	getEnumName = false,
) => {
	switch (+refundPolicyByValue) {
		case 0:
			return getEnumName ? "RefundWithin30Days" : "Refund Within 30 Days";
		case 1:
			return getEnumName ? "ExchangeOnly" : "Exchange Only";
		case 2:
			return "Other";
		case 3:
			return "None";
		default:
			return "";
	}
};

export const AttachmentDocumentName = documentName => {
	switch (+documentName) {
		case 0:
			return "Bank Letter";
		case 1:
			return "Photo Identification";
		case 2:
			return "Tax Return";
		case 3:
			return "Bank Statement";
		case 4:
			return "Voided Check";
		case 5:
			return "Business License";
		case 6:
			return "Utility Bill";
		case 7:
			return "Previous Processor Statements";
		case 8:
			return "Application (Unredacted)";
		case 9:
			return "Other Underwriting Documentation";
		case 10:
			return "Equipment Ordering Form";
		case 11:
			return "Underwriting Document";
		case 12:
			return "Agent Contract";
		case 13:
			return "Signed Schedule A";
		case 14:
			return "Residual Split Profile Email";
		case 15:
			return "Other";
		case 16:
			return "NailSoft Set Up";
		default:
			return "Unknown";
	}
};

export const GetAttachmentImagePath = type => {
	switch (+type) {
		case 0:
			return BankLetter;
		case 1:
			return PhotoIdentification;
		case 2:
			return TaxReturn;
		case 3:
			return BankStatement;
		case 4:
			return VoidedCheck;
		case 5:
			return BusinessLicense;
		case 6:
			return UtilityBill;
		case 7:
			return PreviousProcessorStatements;
		case 8:
			return ApplicationUnredacted;
		case 9:
			return OtherUnderwritingDocument;
		case 10:
			return OtherUnderwritingDocument;
		case 11:
			return UnderwritingDocument;
		case 12:
			return AgentContract;
		case 13:
			return SignedScheduleA;
		case 14:
			return ResidualSplitProfileEmail;
		case 15:
			return OtherDocument;
		default:
			return undefined;
	}
};

export const CreditDebitByValueTypeCart = (
	creditDebitByValueTypeCart,
	getEnumName = false,
) => {
	creditDebitByValueTypeCart = +creditDebitByValueTypeCart;
	switch (creditDebitByValueTypeCart) {
		case 0:
			return getEnumName ? "DateOfOrder" : "Date of Order";
		case 1:
			return getEnumName ? "DateOfShipment" : "Date of Shipment";
		case 2:
			return "Other";
		default:
			return "";
	}
};

export const MiscFeeMonth = miscFeeMonth => {
	switch (miscFeeMonth) {
		case "Jan":
			return "January";
		case "Feb":
			return "February";
		case "Mar":
			return "March";
		case "Apr":
			return "April";
		case "May":
			return "May";
		case "Jun":
			return "June";
		case "Jul":
			return "July";
		case "Aug":
			return "August";
		case "Sep":
			return "September";
		case "Oct":
			return "November";
		case "Nov":
			return "November";
		case "Dec":
			return "December";
		default:
			return "Invalid";
	}
};

export const AmexTypeByValue = (amexType, getEnumName = false) => {
	switch (+amexType) {
		case 0:
			return getEnumName ? "None" : "No Amex";
		case 1:
			return getEnumName ? "Esa" : "ESA";
		case 2:
			return getEnumName ? "OptBlue" : "Opt Blue";
		default:
			return undefined;
	}
};

export const merchantTypes = {
	NEW: "new",
	ADDITIONAL_LOCATION: "additional_location",
};
export const MerchantTypeByValue = merchantType => {
	switch (merchantType) {
		case merchantTypes.NEW:
			return "New";
		case merchantTypes.ADDITIONAL_LOCATION:
			return "Additional Location";
		default:
			return undefined;
	}
};

export const documentationMailingAddressTypes = {
	LEGAL_ADDRESS: "legal_address",
	DBA_ADDRESS: "dba_address",
};
export const DocumentationMailingAddress = type => {
	switch (type) {
		case documentationMailingAddressTypes.LEGAL_ADDRESS:
			return "Legal Address";
		case documentationMailingAddressTypes.DBA_ADDRESS:
			return "DBA Address";
		default:
			return undefined;
	}
};

export const excludeCardTypes = {
	VISA: "visa",
	MASTER_CARD: "master_card",
	DISCOVER: "discover",
	AMEX: "amex",
	PAY_PAL: "pay_pal",
};
export const ExcludeCardTypes = card => {
	switch (card) {
		case excludeCardTypes.VISA:
			return "Visa";
		case excludeCardTypes.MASTER_CARD:
			return "Mastercard";
		case excludeCardTypes.DISCOVER:
			return "Discover";
		case excludeCardTypes.AMEX:
			return "AMEX";
		case excludeCardTypes.PAY_PAL:
			return "Pay Pal";
		default:
			return undefined;
	}
};

export const siteInspectionByTypes = {
	AGENT: "agent",
	AURORA: "aurora",
};
export const SiteInspectionBy = type => {
	switch (type) {
		case siteInspectionByTypes.AGENT:
			return "Agent";
		case siteInspectionByTypes.AURORA:
			return "Aurora";
		default:
			return undefined;
	}
};

export const toBeBilledTypes = {
	MONTHLY: 0,
	ANNUALLY: 1,
};
export const ToBeBilledByValue = type => {
	switch (type) {
		case toBeBilledTypes.MONTHLY:
			return "Monthly";
		case toBeBilledTypes.ANNUALLY:
			return "Annually";
		default:
			return undefined;
	}
};

export const DiscountTypeByValue = type => {
	switch (+type) {
		case 0:
			return "Individual / Deposit";
		case 1:
			return "Combined";
		default:
			return undefined;
	}
};

export const IsMonthEndByValue = type => {
	switch (type) {
		case true:
			return "Month End Discount";
		case false:
			return "Daily Discount";
		default:
			return undefined;
	}
};
